import { render, staticRenderFns } from "./LeaderboardTeams.vue?vue&type=template&id=50b763c4&scoped=true"
import script from "./LeaderboardTeams.vue?vue&type=script&lang=js"
export * from "./LeaderboardTeams.vue?vue&type=script&lang=js"
import style0 from "./LeaderboardTeams.vue?vue&type=style&index=0&id=50b763c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b763c4",
  null
  
)

export default component.exports